/* eslint-disable */

import { sendMore } from './send-more';
const moreBtn = document.getElementById('sendmorereq');
if (moreBtn)
  moreBtn.addEventListener('click', e => {
    var elements = document.getElementById("knowMoreForm").elements;
    const token = document.querySelector('#knowMoreForm [name="cf-turnstile-response"]')?.value;
    var obj ={};
    for(var i = 0; i < elements.length; i++){
        var item = elements.item(i);
        obj[item.name] = item.value;
    }
    sendMore(obj, token);
});